/* eslint-disable */
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { doc, where, updateDoc } from "firebase/firestore";
import { db } from "../../firebase-config";
import StarRating from "../../components/CaseComponents/StarRating";
import '../../Styles/ValuatorStyles/StarRating.css';
import  useNavigation  from "../../hooks/useNavigation";
import useFetchData from '../../hooks/ValuatorHooks/useFetchData';
import { useSelectedCompany } from "../../contexts/SelectedCompanyContext";
import useFetchCompanyId from "../../hooks/CompanyHooks/useFetchCompanyId";



function ValuatePage () {
    const [ratings, setRatings] = useState({});
    const {selectedCompany} = useSelectedCompany();
    const { companyId } = useFetchCompanyId(selectedCompany);
    const [otherComment, setOtherComment] = useState("");
    const [caseDetails, setCaseDetails] = useState({
      ratings: [],
      done: false,
      otherComment: "",
      questionsAnswered: []
    });
    const { caseId } = useParams();
    const { navigateTo } = useNavigation();
    const { data: companyData, loading: companyLoading, error: companyError } = useFetchData('companies', null, [where('company', '==', selectedCompany)]);
    const { data: questions, loading: questionsLoading, error: questionsError } = useFetchData('companies', companyId ? `${companyId}/questions/HJKoNf2eABC3ONUGtRbS` : null);


    const questionOrder = ['question1', 'question2', 'question3', 'question4'];

    useEffect(() => {

      if (companyData && companyData.length > 0) {
          const companyDoc = companyData[0];
          if (companyDoc.cases && companyDoc.cases[caseId]) {
              setCaseDetails(companyDoc.cases[caseId]);
          }
      }
  }, [companyData, caseId]);

  const handleRatingChange = (questionKey, value) => {
    setRatings({
      ...ratings,
      [questionKey]: value
    });

    setCaseDetails(prevCaseDetails => {
        const updatedQuestions = prevCaseDetails.questionsAnswered.filter(q => q.key !== questionKey);
        updatedQuestions.push({ key: questionKey, answer: value });

        return {
            ...prevCaseDetails,
            questionsAnswered: updatedQuestions
        };
    });
};

      const handleSubmit = async (e) => {
        e.preventDefault();
          const answersArray = questionOrder.map(questionKey => {
          const questionText = questions[questionKey]?.text || "Unknown Question";
          const rating = ratings[questionKey] || 0;
          return `${questionText}: ${rating}`;
      });
  
      try {
          const caseRef = doc(db, "companies", companyId, "cases", caseId);
          await updateDoc(caseRef, {
              questionsAnswered: answersArray, 
              done: true,
              otherComment: otherComment
          });
          alert("Rating og kommentar er nu gemt!");
          navigateTo('/valuator/cases');
      } catch (error) {
          console.error("Error submitting ratings and comments:", error);
          alert("Noget gik galt under oprettelsen af rating of kommentar!");
      }
  };
      
      return (
        <form onSubmit={handleSubmit}>
            <div className="rating-container">
                <h1 className="main-header">
                    Indtast Rating
                </h1>
                {questions && questionOrder.map((key, index) => {
    const question = questions[key];
    return question ? (
        <StarRating
            key={key}
            rating={ratings[key] || 0}
            onRatingChange={handleRatingChange}
            questionKey={key}
            questionText={question.text}
        />
    ) : null;
})}

                <textarea
                    placeholder="Yderligere kommentare?"
                    value={otherComment}
                    onChange={(e) => setOtherComment(e.target.value)}
                    className="other-comment-textarea"
                ></textarea>
    
                <div className="submit-container">
                    <button type="submit" className="submit-rating-btn">Send Rating</button>
                </div>
            </div>
        </form>
    );      
}
export default ValuatePage;